import lodash from './lodash'

export default app => {
  app.use(lodash)
}
